import React from "react";
import CookieImage from "./CookieImage";

// boxSize: 1, 2, 4, 6, 12. picks: array of {flavor_id, image_key} length = totalSelected (<= boxSize)
export default function BakeryBox({ boxSize = 6, picks = [], total = 0 }) {
  const cols = boxSize === 1 ? 1 : boxSize === 2 ? 2 : boxSize === 4 ? 2 : boxSize === 6 ? 3 : 4;
  const slots = Array.from({ length: boxSize }, (_, i) => picks[i] || null);
  return (
    <div className="bakery-box w-full max-w-md mx-auto" data-testid="bakery-box">
      <div
        className="grid gap-3 md:gap-4"
        style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
      >
        {slots.map((p, i) => (
          <div key={i} className={`bakery-slot ${p ? "filled" : ""}`} data-testid={`bakery-slot-${i}`}>
            {p && <CookieImage flavorKey={p.image_key} imageUrl={p.image_url} className="w-full h-full" />}
          </div>
        ))}
      </div>
      <div className="mt-4 text-center font-display font-extrabold text-[#FF1F87] tracking-wider" data-testid="bakery-box-count">
        {total} / {boxSize} SELECTED
      </div>
    </div>
  );
}
